import { useState } from 'react';

function useMembershipFilter(setCurrentPage) {
    const [selectedMemberships , setSelectedMemberships] = useState([]);

    const handleMembershipChange = (mem) => {
        setSelectedMemberships(prev => {
            if (prev.includes(mem)) {
                return prev.filter(m => m !== mem);
            } else {
                return [...prev, mem];
            }
        });
        if (setCurrentPage) {
            setCurrentPage(1); // Reset to first page when membership change
        }
    };

    return { selectedMemberships, handleMembershipChange, setSelectedMemberships };
}

export default useMembershipFilter;